import { RouteLocation, RouteRecordRaw } from 'vue-router'
import LocationsChildRoutes from '@/router/measure-locations'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'edit',
    name: 'control-panel.section.edit',
    component: () => import('@/views/control-panel/projects/project/sections/section/Edit.vue'),
  },
  {
    path: 'logbook',
    name: 'section.logbook',
    component: () => import('@/views/control-panel/projects/project/sections/section/Logbook.vue'),
  },
  {
    path: 'water-extraction-summary',
    name: 'section.waterExtractionSummary',
    component: () => import('@/views/control-panel/projects/project/sections/section/WaterExtractionSummary.vue'),
  },
  {
    path: 'measure-locations',
    name: 'measure-locations',
    component: () => import('@/views/control-panel/projects/project/sections/section/MeasureLocations.vue'),
    meta: { title: 'Alle deelprojecten' },
    redirect: (to: RouteLocation) => ({ name: 'map.locations', params: to.params }),
    children: LocationsChildRoutes
  },
  {
    path: 'geojson',
    name: 'section.geojson',
    component: () => import('@/views/control-panel/projects/project/sections/section/GeoJson.vue'),
    redirect: () => ({ name: 'section.geojson.list' }),
    children: [
      {
        path: 'list',
        name: 'section.geojson.list',
        component: () => import('@/views/control-panel/projects/project/sections/section/geojson/List.vue'),
      }
    ]
  }
]

export default routes
